var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status=default",
    clipPath: "url(#clip0_9146_80459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9907 3.00656C15.2007 1.21656 12.299 1.21656 10.509 3.00656C10.3665 3.14906 9.81817 3.6974 9.67567 3.8399C8.38567 5.1299 8.03984 6.99489 8.60984 8.60823C6.9965 8.03823 5.13234 8.38323 3.84234 9.67323C3.69984 9.81573 3.1515 10.3641 3.009 10.5066C1.219 12.2966 1.219 15.1982 3.009 16.9882C4.799 18.7782 7.70067 18.7782 9.49067 16.9882C9.63317 16.8457 10.1815 16.2974 10.324 16.1549C11.614 14.8649 11.9598 12.9999 11.3898 11.3866C13.0032 11.9566 14.8673 11.6116 16.1573 10.3216C16.2998 10.1791 16.8482 9.63073 16.9907 9.48823C18.7807 7.69823 18.7807 4.79656 16.9907 3.00656Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6783 6.32406C13.0275 5.67323 11.9725 5.67323 11.3216 6.32406L6.32162 11.3241C5.67079 11.9749 5.67079 13.0299 6.32162 13.6807C6.97245 14.3316 8.02745 14.3316 8.67829 13.6807L13.6783 8.68073C14.3291 8.0299 14.3291 6.9749 13.6783 6.32406Z",
    fill: "#2894FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_80459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlue);
export default __webpack_public_path__ + "static/media/link-blue.5fb78dbcff1361495c400af897cf3161.svg";
export { ForwardRef as ReactComponent };